import { render, staticRenderFns } from "./variable-row.vue?vue&type=template&id=97283e4a&scoped=true&"
import script from "./variable-row.vue?vue&type=script&lang=ts&"
export * from "./variable-row.vue?vue&type=script&lang=ts&"
import style0 from "./variable-row.vue?vue&type=style&index=0&id=97283e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97283e4a",
  null
  
)

export default component.exports